export const brandCodes = [
  "cre",
  "crystalglass",
  "fixaut",
  "nationrestoration", // Fix Nation Restauration
  "novusglass",
  "proc",
  "speedyauto",
  "speedyglass",
] as const;

export const brandTwoLetterCodes = [
  "CR",
  "FA",
  "NC",
  "NG",
  "NR",
  "PC",
  "SA",
  "SG",
] as const;

export const regionCodes = ["au", "ca", "de", "mx", "nz", "us"] as const;

export type BrandCode = (typeof brandCodes)[number];
export type BrandTwoLetterCode = (typeof brandTwoLetterCodes)[number];
export type RegionCode = (typeof regionCodes)[number];
export type BRCYCodes = Uppercase<`${BrandTwoLetterCode}${RegionCode}`>;

export const brandRegionCodes = [
  "creca",
  "crystalglassca",
  "fixautau",
  "fixautca",
  "fixautde",
  "fixautmx",
  "nationrestorationca",
  "novusglassau",
  "novusglassca",
  "novusglassus",
  "procca",
  "procus",
  "speedyautoca",
  "speedyglassus",
] as const satisfies `${BrandCode}${RegionCode}`[];

export type BrandRegionCode = (typeof brandRegionCodes)[number];

export const brandRegionCodeRegionMap: Record<BrandRegionCode, RegionCode> = {
  creca: "ca",
  crystalglassca: "ca",
  fixautau: "au",
  fixautca: "ca",
  fixautde: "de",
  fixautmx: "mx",
  nationrestorationca: "ca",
  novusglassau: "au",
  novusglassca: "ca",
  novusglassus: "us",
  procca: "ca",
  procus: "us",
  speedyautoca: "ca",
  speedyglassus: "us",
} as const;
